<template>
  <div
    id="page-table"
    :class="className"
    v-loading="customLoading"
    :element-loading-text="loadingText"
  >
    <!-- 显示表格 -->
    <el-table
      style="width: 100%"
      ref="table"
      v-loading="loading"
      :size="size"
      :lazy="lazy"
      :load="load"
      :border = "border"
      :show-summary = "isShowSum"
      :summary-method="getSummaries"
      :row-key="rowKey"
      :data="tableData"
      :height="tableHeight"
      :max-height = "maxHeight"
      :tree-props="treeProps"
      :cell-style="cellStyle"
      :cell-class-name="cellClassName"
      :span-method="spanMethod"
      :row-class-name="rowClassName"
      :element-loading-text="loadingText"
      :header-cell-style="headerCellStyle"
      :header-row-class-name = "headerRowClass"
      :highlight-current-row="highlightCurrentRow"
      @sort-change="sortChange"
      @cell-click="handleCellClick"
      @row-click="handleRowClick"
      @cell-mouse-leave="cellMouseLeave"
      @cell-mouse-enter="cellMouseEnter"
      @select="select"
      @select-all="selectAll"
      @selection-change="selectionChange"
    >
      <!-- 选择框 -->
      <el-table-column
        v-if="checkBox"
        :key="'selection'"
        :selectable="selectable"
        fixed="left"
        type="selection"
        :reserve-selection="reserveSelection"
        width="45"
      />
      <!-- 序号 -->
      <el-table-column
        v-if="tabIndex"
        :key="'index'"
        align="left"
        header-align="left"
        label="序号"
        :width="fieldList.length === 0 ? '' : 80"
        fixed
      >
        <template v-slot="scope">
          <span>{{
            scope.$index + 1 + (pageRequest.pageNo - 1) * pageRequest.pageSize
          }}</span>
        </template>
      </el-table-column>
      <!-- 列内容 -->
      <el-table-column
        v-for="(item, index) in fieldList.filter((item) => !item.hidden)"
        :key="index"
        :prop="item.props"
        :label="item.label"
        :fixed="item.fixed"
        :align="item.align || 'left'"
        :header-align="item.headerAlign || 'left'"
        :width="item.width"
        :sortable="item.sortable"
        :min-width="item.minWidth || '100'"
        :show-overflow-tooltip="item.overflow"
      >
        <el-table-column
          v-for="col in item.secondRow"
          :key="col.props"
          :prop="col.props"
          :label="col.label"
          :width="col.width"
          :min-width="col.minWidth"
          :show-overflow-tooltip="col.overflow"
        >
          <template v-if="col.header" v-slot:header="scope">
            <slot :name="'header-' + col.props" :row="col.row" :item="col" />
          </template>
          <template v-slot="scope">
            <template v-if="col.type === 'slot'">
              <slot
                :name="'col-' + col.props"
                :row="scope.row"
                :item="col"
                :rowIndex="scope.$index"
              />
            </template>
            <span v-else-if="col.type === 'date'">
              {{ scope.row[col.props]?$formart(scope.row[col.props], col.dateType):'-' }}
            </span>
            <template v-else>
              {{ scope.row[col.props] || "-" }}
            </template>
          </template>
        </el-table-column>
        <!-- 自定义表头 -->
        <template v-if="item.header" v-slot:header="scope">
          <slot :name="'header-' + item.props" :row="scope.row" :item="item" />
        </template>
        <!-- 嵌套表格 -->
        <template v-if="item.children">
          <el-table-column
            v-for="(childItem, childIndex) in item.children"
            :key="childIndex"
            :prop="childItem.props"
            :label="childItem.label"
            :align="childItem.align || 'left'"
            :header-align="childItem.headerAlign || 'left'"
            :width="childItem.width"
            :show-overflow-tooltip="childItem.overflow"
            :min-width="childItem.minWidth || '85px'"
          >
               <!-- 自定义表头 -->
              <template v-if="childItem.header" v-slot:header="scope">
                <slot :name="'header-' + childItem.props" :row="scope.row" :childItem="childItem" />
              </template>
              <!-- solt 自定义列-->
              <template v-slot="scope">
                <template v-if="childItem.type === 'slot'">
                  <slot
                    :name="'col-' + childItem.props"
                    :row="scope.row"
                    :item="childItem"
                    :parentItem = "item"
                    :rowIndex="scope.$index"
                  />
                </template>
                <!-- 点击链接 -->
                <span v-else-if="childItem.type === 'link'" class = "mk-link">
                  {{ scope.row[childItem.props] }}
                </span>
                <!-- 日期 -->
                <span v-else-if="childItem.type === 'date'">
                  {{ scope.row[childItem.props]?$formart(scope.row[childItem.props], childItem.dateType):'-' }}
                </span>
                <!-- 数值两位小数 -->
                <span v-else-if="childItem.type === 'number'">
                  {{ scope.row[childItem.props]?Number(Number(scope.row[childItem.props]).toFixed(2)):"" }}
                </span>
                <!-- 金额带符号-->
                <span v-else-if="childItem.type === '$money'">
                   <span v-if = "scope.row[childItem.props]">
                     ￥{{ currencys($changeNumber(scope.row[childItem.props])) }}
                   </span>
                   <span v-else>
                     -
                   </span>
                </span>
                <!-- 金额 -->
                <span v-else-if="childItem.type === 'money'">
                  {{ currencys($changeNumber(scope.row[childItem.props])) }}
                </span>
                <!-- 金额带0 -->
                 <span v-else-if="childItem.type === 'moneys'">
                  {{ currencys($changeNumber(scope.row[childItem.props]))?currencys($changeNumber(scope.row[childItem.props])):0 }}
                </span>
                <!-- 正常文本 -->
                <span v-else>{{ scope.row[childItem.props] == 0 ? 0 : scope.row[childItem.props] ? scope.row[childItem.props] : '-' }}</span>
              </template>
          </el-table-column>
        </template>
        <template v-slot="scope">
          <!-- solt 自定义列-->
          <template v-if="item.type === 'slot'">
            <slot
              :name="'col-' + item.props"
              :row="scope.row"
              :item="item"
              :rowIndex="scope.$index"
            />
          </template>

          <!-- 标签 -->
          <el-tag v-else-if="item.type === 'tag'">
            {{ scope.row[item.props] }}
          </el-tag>
          <!-- 数值两位小数 -->
          <span v-else-if="item.type === 'number'">
            {{ scope.row[item.props]?Number(Number(scope.row[item.props]).toFixed(2)):"" }}
          </span>
          <!-- 金额带符号-->
          <span v-else-if="item.type === '$money'">
            <span v-if = "scope.row[item.props]">
              ￥{{ currencys($changeNumber(scope.row[item.props])) }}
            </span>
            <span v-else>
              -
            </span>
          </span>
          <!-- 金额 -->
          <span v-else-if="item.type === 'money'">
            {{ currencys($changeNumber(scope.row[item.props])) }}
          </span>
          <!-- 金额带0 -->
          <span v-else-if="item.type === 'moneys'">
            {{ currencys($changeNumber(scope.row[item.props]))?currencys($changeNumber(scope.row[item.props])):0 }}
          </span>
          <!-- 时间 -->
          <span v-else-if="item.type === 'date'">
            {{ scope.row[item.props]?$formart(scope.row[item.props], item.dateType):'-' }}
          </span>
          <!-- 字典替换 props => label -->
          <span v-else-if="item.type === 'dir'">
            {{
              $getDataName({
                dataList: listTypeInfo[item.list],
                value: "value",
                label: "label",
                data: scope.row[item.props]
              }) || "-"
            }}
          </span>
          <!-- 点击链接 -->
          <span v-else-if="item.type === 'link'" class = "mk-link">
            {{ scope.row[item.props] }}
          </span>
          <!-- 金额 -->
          <span v-else-if="item.type === 'money'">
            {{ currencys($changeNumber(scope.row[item.props])) }}
          </span>
          <!-- 正常文本 -->
          <span v-else>{{ scope.row[item.props] === 0 ? 0 : scope.row[item.props] ? scope.row[item.props] : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="handle"
        key="handle"
        align="center"
        :fixed="handle.fixed"
        :label="handle.label"
        :width="handle.width"
      >
        <template v-slot="scope">
          <template v-for="(item, index) in handle.btList">
            <!-- 自定义操作类型 -->
            <slot
              v-if="item.slot"
              :name="'bt-' + item.event"
              :data="{ item, row: scope.row }"
            />
            <!-- 操作按钮 -->
            <el-button
              v-if="
                !item.slot &&
                item.show &&
                (!item.ifRender || item.ifRender(scope.row))
              "
              :key="index"
              :size="item.size || 'mini'"
              :type="item.type"
              :icon="item.icon"
              :disabled="item.disabled"
              :loading="scope.row[item.loading]"
              @click="handleClick(item.event, scope.row)"
              >{{ item.label }}</el-button
            >
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <template v-if="pager">
      <div v-show="!loading" class="pagination-container">
        <el-pagination
          background
          ref='pagination'
          small
          layout="total, prev, pager, next, sizes, jumper"
          :current-page.sync="pageRequest.pageNo"
          :page-sizes="pageSizes"
          :page-size="pageRequest.pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />

        <!-- @prev-click="pageIndexChange"
        @next-click="pageIndexChange"-->
      </div>
    </template>
  </div>
</template>

<script>
import { currencys } from "@/assets/utils/currencyFormat.js"
export default {
  name: "PublicTable",
  props: {
    // 禁用复选框
    selectable: {
      type: Function,
      default:()=>{ return true }
    },
    // 移出行
    cellMouseLeave:{
      type: Function,
      default:()=>{}
    },
    // 是否显示合计
    isShowSum: {
      type: Boolean,
      default: false
    },
    // 合计方法
    getSummaries:{
      type: Function,
      default:()=>{}
    },
    // 移入行
    cellMouseEnter:{
      type: Function,
      default:()=>{}
    },
    // 自定义类名
    className: {
      type: String
    },
    // loading, 一种是外部盒子，一种是表格
    customLoading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: "请稍等..."
    },
    border: {
      type: Boolean,
      default: true
    },
    // 是否懒加载子节点数据
    lazy: {
      type: Boolean,
      default: false
    },
    // 加载子节点数据的函数，lazy 为 true 时生效，函数第二个参数包含了节点的层级信息
    load: {
      type: Function,
      default: () => {}
    },
    // 行数据的 Key，用来优化 Table 的渲染；
    rowKey: {
      type: [String,Function],
      default: ""
    },
    // 渲染嵌套数据的配置选项
    treeProps: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 表格尺寸
    size: {
      type: String,
      default: "small"
    },
    tableHeight: {
      type: [String, Number],
      default: null
    },
    maxHeight: {
      type: [String, Number],
      default: null
    },
    // 行的 className 的回调方法
    rowClassName: {
      type: [String, Function],
      default: ""
    },
    // 是否要高亮当前行
    highlightCurrentRow: {
      type: Boolean,
      default: false
    },
    // 单元格 className 的回调方法
    cellStyle: {
      type: [Object, Function],
      default: () => {}
    },
    cellClassName: {
      type: [String, Function],
      default: () => {}
    },
    // 表头单元格的 style 的回调方法，也可以使用一个固定的 Object 为所有表头单元格设置一样的 Style。
    headerCellStyle: {
      type: [Object, Function],
      default: () => {}
    },
    headerRowClass: {
      type: [String, Function],
      default: ""
    },
    // 合并行或列的计算方法
    spanMethod: {
      type: [Function],
      default: () => {}
    },
    // 刷新
    refresh: {
      type: Number
    },
    // 是否显示序号
    tabIndex: {
      type: Boolean,
      default: false
    },
    // 是否有选择框
    checkBox: {
      type: Boolean,
      default: false
    },
    // 选中列表
    checkedList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 类型列表
    listTypeInfo: {
      type: Object
    },
    // 表格字段配置
    fieldList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 操作栏配置
    handle: {
      type: Object,
      default: () => {}
    },
    // 是否分页
    pager: {
      type: Boolean,
      default: true
    },
    // 重置当前页
    initCurpage: {
      type: Number
    },
    // 查询条件
    query: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 列表数据
    data: {
      type: [Array, Object]
    },
    // 自定义分页间隔
    pageSizes: {
      type: Array,
      default: () => {
        return [10,20,30,40,50,100]
      }
    },
    // 数据更新之后保留之前选中的数据
    reserveSelection: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 列表相关
      currencys,
      pageRequest: {
        pageNo: 1, // 当前页
        pageSize: this.$store ? this.$store.getters.pageSize : 30 // 每页条数
      },
      loading: false
    };
  },
  computed: {
    tableData() {
      if(!this.data) return [];
      return Array.isArray(this.data) ? this.data : this.data.list;
    },
    total() {
      if(!this.data) return 0;
      return Array.isArray(this.data) ? null : (this.data.count || this.data.total || this.data.totalCount);
    }
  },
  watch: {
    initCurpage() {
      this.pageRequest.pageNo = 1;
    }
  },
  methods: {
    // 修改总条数
    changePagerTotal(total) {
      total ? this.pageRequest.pageSize = total : false
    },
    findPage() {
      this.loading = true;
      const callback = () => {
        this.loading = false;
      };
      this.$emit("findPage", {
        pageRequest: this.pageRequest,
        callback
      });
    },
    // 切换每页显示条数
    handleSizeChange(val) {
      const pageRequest = this.pageRequest;
      // 每页条数
      pageRequest.pageSize = val;
      // 每页条数切换，重置当前页
      // pageRequest.pageNo = 1;
      this.findPage();
    },
    // 点击对应页面跳转页
    handleCurrentChange(val) {
      // 当前页
      this.pageRequest.pageNo = val;
      this.findPage();
    },
    // 排序事件触发
    sortChange({ column, prop, order }) {
      this.$emit("sortChange", column, prop, order);
    },
    clearSort() {
      this.$refs.table.clearSort();
    },
    // 点击单元格
    handleCellClick(row, column, cell, event) {
      this.$emit("cellClick", row, column, cell, event);
    },
    // 点击行
    handleRowClick(row, column, event) {
      this.$emit("rowClick", row, column, event);
    },
    // 派发按钮点击事件
    handleClick(event, data) {
      this.$emit("handleClick", event, data);
    },
    // 勾选数据
    select(selection, row) {
      this.$emit("select", selection, row);
    },
    // 全选数据
    selectAll(selection) {
      this.$emit("select-all", selection);
      this.handleSelectionChange(selection);
    },
    // 选项发生改变
    selectionChange(selection) {
      this.$emit("selection-change", selection);
      this.handleSelectionChange(selection);
    },
    // 选中数据
    handleSelectionChange(rows) {
      this.$emit("handleEvent", rows);
    },
    // 获取已选中的行数据
    getCheckboxRecords() {
      return this.$refs.table.selection;
    },
    // 用于单选表格，设定某一行为选中行，如果调用时不加参数，则会取消目前高亮行的选中状态。
    async setCurrentRow(row) {
      await this.$nextTick();
      this.$refs.table.setCurrentRow(row);
    },
    // 用于多选表格，切换某一行的选中状态，如果使用了第二个参数，则是设置这一行选中与否（selected 为 true 则选中）
    async toggleRowSelection(row, selected = true) {
      await this.$nextTick();
      this.$refs.table.toggleRowSelection(row, selected);
    },
    // 用于多选表格，清空用户的选择
    async clearSelection() {
      await this.$nextTick();
      this.$refs.table.clearSelection();
    },
    // 对 Table 进行重新布局。当 Table 或其祖先元素由隐藏切换为显示时，可能需要调用此方法
    doLayout() {
      this.$refs.table.doLayout();
    }
  }
};
</script>

<style lang="less">
// 自定义表格相关
#page-table {
   thead{
    td,th{
      .cell {
        height: 27px;
      }
    }
   }
  .el-table {
    th {
      background: #f6f8fa !important;
    }
  }
  th {
    font-size: 14px;
    padding: 6px 0;
    color: #4a4a4a;
    border-color: #e6e6e6;
  }
  td,
  th {
    .cell {
      line-height: 27px;
    }
    color: #4a4a4a;
  }
  .pagination-container {
    text-align: right;
    margin-top: 15px;
    .el-pagination {
      display: inline-block;
    }
    .el-input--mini .el-input__inner {
      height: 22px;
      line-height: 22px;
    }
    .el-pagination__jump {
      margin-left: 10px;
    }
    .pageBtn {
      height: 25px;
      padding: 2px 5px;
      font-size: 12px;
    }
  }
  .el-table--enable-row-hover .el-table__body tr:hover>td {
			background-color: #eff9f6;
		}
  // 合并组hover颜色
  .success-row {
    background: #eff9f6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonTable/index.vue